import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { RiskAnalysisSection } from '../../containers/adherence/risk-analysis/risk-analysis.client.type';
import { createSafeJSONStorage } from '../../helpers/storage/persist-storage';
import type { State } from './adherence-store.type';
import { AdherenceTab } from './adherence-store.type';

export const useAdherenceStore = create<State>()(
  persist(
    (set) => ({
      selectedRiskAnalysisSection: RiskAnalysisSection.TASKS,
      setSelectedRiskAnalysisSection: (section: RiskAnalysisSection) => set({ selectedRiskAnalysisSection: section }),
      selectedTab: AdherenceTab.RISK_ANALYSIS,
      setSelectedTab: (tab: AdherenceTab) => set({ selectedTab: tab }),
    }),
    {
      name: 'adherence-store',
      storage: createSafeJSONStorage(() => localStorage),
    },
  ),
);
